import { useMemo } from 'react';

import { getAccessLevel } from '@/utils';

import { useListRoles, useListUsers } from './api';

export type UseListReviewersOpts = {
  agentId?: string;
};

export const useListReviewers = ({ agentId }: UseListReviewersOpts = {}) => {
  const { data: { data: users } = {} } = useListUsers();
  const { data: { data: roles } = {} } = useListRoles();

  const reviewers = useMemo(() => {
    return users?.filter((user) => {
      const userRoles = roles?.filter((role) => user?.roleIds.includes(role.roleId));
      const accessLevels = userRoles?.map((role) => getAccessLevel(role.permissions, agentId));
      return accessLevels?.some((a) => a != null);
    });
  }, [agentId, roles, users]);

  return { users: reviewers };
};
